/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListMcpServersSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListMcpServersSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListMcpServersSecurity = {
  option1?: ListMcpServersSecurityOption1 | undefined;
  option2?: ListMcpServersSecurityOption2 | undefined;
};

export type ListMcpServersRequest = {
  /**
   * Filter to MCP servers backed by this remote MCP server
   */
  remoteMcpServerId?: string | undefined;
  /**
   * Filter to MCP servers backed by this tunneled MCP server
   */
  tunneledMcpServerId?: string | undefined;
  /**
   * Filter to MCP servers backed by this toolset
   */
  toolsetId?: string | undefined;
  /**
   * Filter to MCP servers backed by this unproxied MCP server
   */
  unproxiedMcpServerId?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListMcpServersSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListMcpServersSecurityOption1$outboundSchema: z.ZodMiniType<
  ListMcpServersSecurityOption1$Outbound,
  ListMcpServersSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listMcpServersSecurityOption1ToJSON(
  listMcpServersSecurityOption1: ListMcpServersSecurityOption1,
): string {
  return JSON.stringify(
    ListMcpServersSecurityOption1$outboundSchema.parse(
      listMcpServersSecurityOption1,
    ),
  );
}

/** @internal */
export type ListMcpServersSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListMcpServersSecurityOption2$outboundSchema: z.ZodMiniType<
  ListMcpServersSecurityOption2$Outbound,
  ListMcpServersSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function listMcpServersSecurityOption2ToJSON(
  listMcpServersSecurityOption2: ListMcpServersSecurityOption2,
): string {
  return JSON.stringify(
    ListMcpServersSecurityOption2$outboundSchema.parse(
      listMcpServersSecurityOption2,
    ),
  );
}

/** @internal */
export type ListMcpServersSecurity$Outbound = {
  Option1?: ListMcpServersSecurityOption1$Outbound | undefined;
  Option2?: ListMcpServersSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListMcpServersSecurity$outboundSchema: z.ZodMiniType<
  ListMcpServersSecurity$Outbound,
  ListMcpServersSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListMcpServersSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListMcpServersSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listMcpServersSecurityToJSON(
  listMcpServersSecurity: ListMcpServersSecurity,
): string {
  return JSON.stringify(
    ListMcpServersSecurity$outboundSchema.parse(listMcpServersSecurity),
  );
}

/** @internal */
export type ListMcpServersRequest$Outbound = {
  remote_mcp_server_id?: string | undefined;
  tunneled_mcp_server_id?: string | undefined;
  toolset_id?: string | undefined;
  unproxied_mcp_server_id?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListMcpServersRequest$outboundSchema: z.ZodMiniType<
  ListMcpServersRequest$Outbound,
  ListMcpServersRequest
> = z.pipe(
  z.object({
    remoteMcpServerId: z.optional(z.string()),
    tunneledMcpServerId: z.optional(z.string()),
    toolsetId: z.optional(z.string()),
    unproxiedMcpServerId: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      remoteMcpServerId: "remote_mcp_server_id",
      tunneledMcpServerId: "tunneled_mcp_server_id",
      toolsetId: "toolset_id",
      unproxiedMcpServerId: "unproxied_mcp_server_id",
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function listMcpServersRequestToJSON(
  listMcpServersRequest: ListMcpServersRequest,
): string {
  return JSON.stringify(
    ListMcpServersRequest$outboundSchema.parse(listMcpServersRequest),
  );
}
